<template>
  <tr>
    <td class="text-ellipsis">
      <div>{{ column.text }}</div>
      <div class="text-neutral md-text-xs font-thin">
        {{ $tc(column.groupName) }}
      </div>
    </td>
    <td class="text-ellipsis">
      <AttributeFieldElement
        :item="item"
        :column="column"
        :disabled="disabled"
      />
    </td>
    <td v-if="!disabled" class="text-left">
      <FlotoDeleteBtn
        :message="$t('confirm_delete_item', { item: `${$tc('attribute')}` })"
        @confirm="handleRemove"
      />
    </td>
  </tr>
</template>

<script>
import AttributeFieldElement from './baseline-attribute-field-element'
export default {
  name: 'AttributeItem',
  components: {
    AttributeFieldElement,
  },
  inject: ['propertyComponentContext'],
  props: {
    column: {
      type: [Array, Object],
      default() {
        return {}
      },
    },
    item: {
      type: Object,
      default() {
        return {}
      },
    },
    update: { type: Function, default: undefined },
    remove: { type: Function, default: undefined },
    itemIndex: { type: Number, default: undefined },
    disabled: { type: Boolean, default: false },
  },
  methods: {
    handleRemove() {
      this.remove()
    },
  },
}
</script>

<style lang="less" scoped>
.ant-form-vertical .ant-form-item {
  padding-bottom: 0;
  margin-bottom: 0;
}
</style>
